export const WELCOME = '/' as const;
export const SIGNINV2 = '/login' as const;
export const SIGNUPV2 = '/sign-up' as const;
